import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import * as Sentry from "@sentry/react";
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/App.css';
import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import { AdsProvider } from 'contexts/AdsContext';
import { AuthProvider } from 'contexts/AuthContext';
import { KisiProvider } from 'contexts/KisiContext';
import { UserProvider } from 'contexts/UserContext';
import { MemberGroupProvider } from 'contexts/MemberGroupContext';
import { AuditProvider } from 'contexts/AuditContext';
import { LocationProvider } from 'contexts/LocationContext';
import { DiscountProvider } from 'contexts/DiscountContext';
import { ServiceProvider } from 'contexts/ServiceContext';
import { DashboardProvider } from 'contexts/DashboardContext';
import { ReportProvider } from 'contexts/ReportContext';
import { PermissionProvider } from 'contexts/PermissionContext';
import { NotificationProvider } from 'contexts/NotificationContext';
import { SettingProvider } from 'contexts/SettingContext';
import { SocketProvider } from 'socket';

Sentry.init({
  dsn: 'https://1de521c3b5a916ec33ea3b23bdcc8cd9@o4508421010030592.ingest.us.sentry.io/4508421074649088',
  integrations: [],
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <AdsProvider>
        <SettingProvider>
          <SocketProvider>
            <KisiProvider>
              <UserProvider>
                <MemberGroupProvider>
                  <LocationProvider>
                    <AuditProvider>
                      <DiscountProvider>
                        <ServiceProvider>
                          <DashboardProvider>
                            <ReportProvider>
                              <PermissionProvider>
                                <NotificationProvider>
                                  <Provider store={store}>
                                    <App />
                                  </Provider>
                                </NotificationProvider>
                              </PermissionProvider>
                            </ReportProvider>
                          </DashboardProvider>
                        </ServiceProvider>
                      </DiscountProvider>
                    </AuditProvider>
                  </LocationProvider>
                </MemberGroupProvider>
              </UserProvider>
            </KisiProvider>
          </SocketProvider>
        </SettingProvider>
      </AdsProvider>
    </AuthProvider>
  </BrowserRouter>
);
